import { mediator } from '@ioc/mediator'
import { RequestData } from 'mediatr-ts'

export class ParaphraseCommand extends RequestData<string[] | undefined> {
  constructor(
    public readonly text: string,
    public readonly level: string,
  ) {
    super()
  }
}

export const paraphrase = (text: string, level: string) =>
  mediator.send<string[] | undefined>(new ParaphraseCommand(text, level))
